/**
 * Creates a custom serializer for a custom type
 * @param serialize Handler that serializes the strongly-typed value to a POJO
 * @param deserialize Handler that deserializes a POJO to the strongly-typed value
 * @param serializeArrayItems Whether to serialize individual array items
 */
export function CreateSerializer(serialize, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
deserialize, serializeArrayItems = true) {
    return {
        serialize,
        deserialize,
        serializeArrayItems,
    };
}
